import { useLocation } from 'react-router-dom';
import { aDondeVaElArea } from '@/router/portadaPorHostname';

/**
 * Manda al área al hostname donde el área funciona.
 *
 * ## El fallo que arregla
 *
 * El bundle y la distribución de CloudFront son los mismos para todos los
 * nombres bajo `ilumetria.com`, así que `/inversionistas/acceso` **se pinta
 * igual en `www.ilumetria.com`**. Lo que no es igual es la API: `capital`
 * declara sus orígenes CORS uno a uno, y en prod sólo admite
 * `https://inversionistas.ilumetria.com`.
 *
 * Resultado: una pantalla de login que se ve perfecta y falla al pulsar
 * «Entrar», con el mensaje «revisa tu conexión» — que manda a mirar el wifi por
 * un problema de configuración. `portadaPorHostname.ts` decía que los enlaces
 * profundos funcionaran desde cualquier hostname «a propósito»; era deliberado
 * y no estaba probado.
 *
 * ## Por qué `window.location` y no un `<Navigate>` de react-router
 *
 * Porque **es otro hostname**. El router navega dentro del documento; cambiar
 * de host es una navegación del navegador. `replace` y no `assign` para no
 * dejar el host roto en el historial: quien pulse «atrás» volvería justo al
 * sitio que no funciona.
 *
 * Se conserva la ruta entera —`pathname` más `search`— para que un enlace
 * guardado a `/inversionistas/panel` siga llevando al panel.
 */
export function AlAreaQueFunciona({ children }: { children: React.ReactNode }) {
  const ubicacion = useLocation();
  const destino = aDondeVaElArea(window.location.hostname);

  if (destino) {
    window.location.replace(`https://${destino}${ubicacion.pathname}${ubicacion.search}`);
    // Nada mientras el navegador se va: pintar la pantalla de acceso durante un
    // instante enseña justo el login que no funciona.
    return null;
  }

  return <>{children}</>;
}
